import React from 'react';
import Stylesheet from './Progress.module.css';

function Progress(props) {
    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Progress}>
                <div className={Stylesheet.Bar} 
                style={{width: `${props.complete}%`}}></div>
            </div>
        </div>
    )
}

export default Progress;